import connect from '@elab/core/store/connect';
import { Form } from '@elab/components/connected/forms/Form';

import { createDispatcher } from '../GenericForm';

import { actions, reducers, sagaFactory, storeName, types } from './redux';

const mapStateToProps = () => ({ storeName });
const mapDispatchToEvents = createDispatcher({
    storeName,
    reducers,
    sagaFactory,
    actions,
    types,
});

export default () =>
    customElements.define(
        'e2-change-email-form',
        connect(mapStateToProps, mapDispatchToEvents)(Form),
    );
